import { PharmacistInterface } from "@/interfaces/user";
import { AxiosResponse } from "axios";
import Vue from "vue";
import HttpService from "./http.service";

export class PharmacistService extends HttpService {
  protected dispensaryUrl: string = process.env.VUE_APP_BASE_URL_DISPENSARY;
  protected uri: string = `${this.dispensaryUrl}/pharmacist`;
  protected defaultSort: string = "name";

  public async get(): Promise<PharmacistInterface[]> {
    const response = await super.get(this.query);
    return response.data.data;
  }

  public async getById(userId: number): Promise<PharmacistInterface[]> {
    const response: AxiosResponse = await Vue.axios({
      method: "GET",
      url: `${this.uri}/${userId}`
    });
    return response.data.data;
  }

  public async post(pharmacistFormData: FormData): Promise<any> {
    const response: AxiosResponse = await Vue.axios({
      method: "POST",
      url: this.uri,
      data: pharmacistFormData
    });
    return response.data.data;
  }

  public async put(pharmacist: PharmacistInterface): Promise<any> {
    const response: AxiosResponse = await Vue.axios({
      method: "PUT",
      url: `${this.uri}/${pharmacist.user_id}`,
      data: pharmacist
    });
    return response.data.data;
  }
}

export const pharmacistService = new PharmacistService();
